import styled from 'styled-components';

import rem from 'polished/lib/helpers/rem';
import toColorString from 'polished/lib/color/toColorString';

import color from '@decisiv/design-tokens/lib/color';
import spacing from '@decisiv/design-tokens/lib/spacing';

// Styles shared by more than one page in the Management tool: the users list
// (PD-4063) uses them in its ACCOUNTS and PERMISSIONS cells, and the Edit User
// header (PD-4068) uses the same tag rows and overflow panel under the name. Both
// pages sit on the same PageSurface.
//
// Real styled components rather than styled-components' `css` prop: portal's
// babel config has no babel-plugin-styled-components, so a `css={...}` would be
// dropped without warning.

export const TagRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(spacing.base / 2)};
`;

// The Popover target. A real button so the trigger is reachable by keyboard and
// exposed as a button to assistive tech — Popover only adds aria-haspopup and
// aria-expanded to whatever element it is handed.
export const OverflowTrigger = styled.button`
  display: flex;
  align-items: center;
  gap: ${rem(spacing.base / 4)};
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${toColorString(color.base.charcoal)};
`;

// Users with many accounts or permissions produce a panel taller than the
// viewport, and Popover does not constrain its own content — so cap the height
// here and let the list scroll instead of running off the screen.
export const OverflowPanel = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(spacing.base / 2)};
  padding: ${rem(spacing.base)};
  white-space: nowrap;
  max-height: min(60vh, ${rem(400)});
  overflow-y: auto;
`;

// One entry inside an expanded panel: a single tag for accounts, or an account
// tag paired with its role tag for permissions.
export const PanelRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem(spacing.base / 2)};
`;

// The page is white edge to edge, all the way down — the shell's ScrollingContent
// is grey (fullMoon), so the surface has to fill it rather than only wrapping the
// content's own height.
export const PageSurface = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: ${toColorString(color.base.snowWhite)};
`;
